module.exports = __webpack_public_path__ + "img/new_bg-m.d2d52144.jpg";